const WifiIcon = ({ size = '20px', color = '#61dafb' }) => (
    <span style={{
        fontSize: size,
        color: color,
        marginRight: '8px',
        display: 'inline-block'
    }}>
        📶
    </span>
);

const ErrorIcon = () => (
    <span style={{
        color: '#dc3545',
        marginRight: '8px',
        fontSize: '18px'
    }}>
        ⚠️
    </span>
);

const UserIcon = () => (
    <span style={{
        marginRight: '8px',
        fontSize: '18px'
    }}>
        👤
    </span>
);

const DeviceIcon = () => (
    <span style={{
        marginRight: '8px',
        fontSize: '18px'
    }}>
        📱
    </span>
);

const DeploymentIcon = () => (
    <span style={{
        marginRight: '8px',
        fontSize: '18px'
    }}>
        🚀
    </span>
);

const SettingsIcon = ({ size = '20px' }) => (
    <span
        style={{
            fontSize: size,
            display: 'inline-block'
        }}
    >
        ⚙️
    </span>
);

export { WifiIcon, ErrorIcon, UserIcon, DeviceIcon, DeploymentIcon, SettingsIcon };